module.exports = __webpack_public_path__ + "img/payme.515ee029.png";